import { render, staticRenderFns } from "./QuotationEditSuccess.vue?vue&type=template&id=0f2b8daa&scoped=true"
import script from "./QuotationEditSuccess.vue?vue&type=script&lang=js"
export * from "./QuotationEditSuccess.vue?vue&type=script&lang=js"
import style0 from "./QuotationEditSuccess.vue?vue&type=style&index=0&id=0f2b8daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b8daa",
  null
  
)

export default component.exports